import { useQuery } from '@tanstack/react-query'
import { StepProps } from '../TimsurveyWizard'
import { timsurveyApi } from '../../../services/api'
import { SituazioneTimsurvey, TimsurveyCasistica } from '../../../types/timsurvey'

export default function StepSituazione({ form, setForm, onNext, onBack, isFirstStep }: StepProps) {
  const { data } = useQuery({
    queryKey: ['timsurvey-casistiche'],
    queryFn: () => timsurveyApi.catalogo.casistiche().then(r => r.data as TimsurveyCasistica[]),
    staleTime: Infinity,
    enabled: form.situazione === 'FUORI_STANDARD',
  })
  const casistiche = data ?? []

  const setSituazione = (val: SituazioneTimsurvey) => setForm(f => ({ ...f, situazione: val }))

  const isSelezionata = (code: string) => form.rilievi.some(r => r.casistica_code === code)
  const quantitaDi = (code: string) => form.rilievi.find(r => r.casistica_code === code)?.quantita ?? null

  const toggleCasistica = (code: string, tipoQuantita: string) => {
    setForm(f => {
      if (f.rilievi.some(r => r.casistica_code === code)) {
        return { ...f, rilievi: f.rilievi.filter(r => r.casistica_code !== code) }
      }
      return { ...f, rilievi: [...f.rilievi, { casistica_code: code, quantita: tipoQuantita === 'NESSUNA' ? null : 0 }] }
    })
  }

  const setQuantita = (code: string, quantita: number) => {
    setForm(f => ({
      ...f,
      rilievi: f.rilievi.map(r => r.casistica_code === code ? { ...r, quantita } : r),
    }))
  }

  const altroSelezionato = isSelezionata('ALTRO')
  const puoAvanzare =
    !!form.situazione &&
    (form.situazione !== 'FUORI_STANDARD' || !altroSelezionato || !!form.fuori_standard_altro_descrizione.trim())

  return (
    <div className="card p-4 space-y-3">
      <div className="grid grid-cols-2 gap-3">
        <button
          className="p-4 rounded-lg border-2 font-medium"
          style={{ borderColor: form.situazione === 'STANDARD' ? '#1E40AF' : '#e5e7eb' }}
          onClick={() => setSituazione('STANDARD')}
        >
          Standard
        </button>
        <button
          className="p-4 rounded-lg border-2 font-medium"
          style={{ borderColor: form.situazione === 'FUORI_STANDARD' ? '#1E40AF' : '#e5e7eb' }}
          onClick={() => setSituazione('FUORI_STANDARD')}
        >
          Fuori standard
        </button>
      </div>

      {form.situazione === 'FUORI_STANDARD' && (
        <div className="space-y-2">
          {casistiche.map(c => (
            <div key={c.code} className="border border-slate-100 rounded-md p-3">
              <label className="flex items-center gap-2">
                <input type="checkbox" checked={isSelezionata(c.code)} onChange={() => toggleCasistica(c.code, c.tipo_quantita)} />
                <span className="text-sm">{c.descrizione}</span>
              </label>
              {isSelezionata(c.code) && c.tipo_quantita !== 'NESSUNA' && (
                <input
                  type="number"
                  inputMode="decimal"
                  className="input mt-2 w-32"
                  placeholder="Quantità"
                  value={quantitaDi(c.code) ?? ''}
                  onChange={e => setQuantita(c.code, Number(e.target.value))}
                />
              )}
            </div>
          ))}
          {altroSelezionato && (
            <div>
              <label className="label">Descrizione (Altro)</label>
              <textarea
                className="input w-full"
                rows={3}
                value={form.fuori_standard_altro_descrizione}
                onChange={e => setForm(f => ({ ...f, fuori_standard_altro_descrizione: e.target.value }))}
              />
            </div>
          )}
        </div>
      )}

      <div className="flex gap-2">
        {!isFirstStep && <button className="btn-secondary" onClick={onBack}>Indietro</button>}
        <button className="btn-primary flex-1" disabled={!puoAvanzare} onClick={onNext}>Avanti</button>
      </div>
    </div>
  )
}
